module.exports = __webpack_public_path__ + "static/media/left.d3249396.svg";